<template>
	<div ref="filtersWrapper" :class="['dc-post-grid-filters-wrapper', 'dc-post-grid-filters-wrapper-filterable', {
		open: open
	}]">

		<button 
			:class="[
				'dropdown-toggle',
				'dc-post-grid-filters-toggle',
				'dc-button',
				'dc-button--has-title',
				'dc-button--has-icon',
				{
					open: open
				}
			]"
			type="button"
			:aria-pressed="(!open) ? false : true" 
			@click.stop.prevent="toggleOpen">
			<legend :for="name">{{ dctxt('filter') }}</legend>
			<span class="menu-dots">
				<span class="dot top"></span>
				<span class="dot middle"></span>
				<span class="dot bottom"></span>
			</span>
		</button>

		<div v-if="filters" :class="['dc-post-grid-dropdowns-wrapper', {
			open: open
		}]">
			<div v-for="filter in filters" :key="'filter-' + filter.name">
				<h3 v-if="filter.name === 'label'">{{ filter.value }}</h3>

				<div
					:class="['dc-post-grid-search-wrapper']"
					v-else-if="filter.type === 'default' && filter.name === 'search'"
				>
					<Search
						:model="filter.value ? filter.value : form.dc_s"
						:searchFormPlaceholder="filter.placeholder"
						v-on:updateSearchTerm="updateSearchTerm"
					/>
				</div>

				<Dropdown
					v-else-if="filter.type === 'default'"
					:label="filter.label"
					:name="filter.name"
					:model="form[filter.name] || []"
					:options="filter.options"
					:multiselect="filter.multiselect || true"
					:initialSelection="filter.initial_selection"
					:showAllOption="filter.show_all_option"
					:gridSettings="gridSettings"
					:open="filter.name === openFilter"
					v-on:toggle-filter="toggleFilter"
					v-on:update-filter="updateAndSearch"
				/>
			</div>
		</div>

		<SelectedFilters 
			v-if="gridSettings.show_selected_filters"
			:form="form"
			:filters="filters"
			v-on:update-filter="updateAndSearch"
			/>

		<input
			v-on:click.stop.prevent="search"
			:id="searchButtonId"
			type="submit"
			tabindex="-1"
			:class="['screen-reader-text', { loading: loading }]"
			:value="Search"
		/>

	</div>
</template>

<script>
import BaseFilters from '@dc-post-grid/layout/Filters.vue';
import SelectedFilters from '@dc-post-grid/layout/filters/SelectedFilters.vue';
export default {
	extends: BaseFilters,
	data() {
		return {
			open: false,
			form: {
				dc_s: this?.initialModel?.dc_s || '',
				paged: 2,
				category: [],
			},
		};
	},
	methods: {
		toggleOpen() {
			this.open = !this.open
		},
	},
	components: {
		SelectedFilters
	},
};
</script>
